import ParentCellOrFragment from '@app/src/components/Table/Cells/ParentCellOrFragment'
import { CircularProgress, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const ScrapingInProgressCell: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <ParentCellOrFragment>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CircularProgress size={24} sx={({ palette }) => ({ color: palette.communication.dark })} />
        <Typography variant="body2" color="text.secondary">
          {formatMessage({
            id: 'resourceCollections.general.screeningStatus',
          })}
        </Typography>
      </Stack>
    </ParentCellOrFragment>
  )
}

export default ScrapingInProgressCell
